// Copyright 2026, Imprivata, Inc.  All rights reserved.

import { initializeTracing } from '@imprivata-cloud/common';
import getConfig from '../appConfigUtils';

const { ZIPKIN_TRACING_URL, OTLP_TRACING_URL, API_URL } = getConfig();
const queryParams = new URLSearchParams(window.location.search);

// TODO: once no more Endpoint Agent versions are sending journeyId,
// remove the journeyId fallback in story VN-20163
const workflowId =
  queryParams.get('workflowId') ??
  (queryParams.get('journeyId') || localStorage.getItem('workflowId') || '');

const tracingInit = initializeTracing({
  workflowId,
  serviceName: 'app-access-web-ui',
  // ignoring .onnx files, they are related to paravision sdk and are cluttering the traces
  ignoreUrls: [/\/models\/.+\.onnx$/],
  propagateTraceHeaderCorsUrls: [RegExp(`^${API_URL}.+`)],
  ZIPKIN_TRACING_URL,
  OTLP_TRACING_URL,
});

export const {
  serviceName,
  updateWorkflowId,
  getWorkflowId,
  getProvider,
  getTracer,
} = tracingInit;
